<template>
  <v-container>
    <v-btn
      color="green"
      dark
      outlined
      id="document_type_create__nuevo__button"
      @click="showDialogDocumentTypeCreate"
      :disabled="isExceeded"
    >
      <v-icon small left>{{ icon.plus }}</v-icon>
      Nuevo tipo de documento
    </v-btn>
    <div class="red--text text--lighten-1 caption" v-if="isExceeded">
      {{ documentsTypeLimitExceededLabel }}
    </div>
    <component
      :is="dialogForm"
      v-model="documentType"
      @onCreate="close"
      @onClose="close"
    />
  </v-container>
</template>

<script>
import { mdiPlus } from '@mdi/js'
import { documentTypeStoreData } from '../store/documentTypeStoreHelpers'
import DocumentTypeDialogForm from '@/modules/catalogs/components/DocumentTypeDialogForm'

export default {
  name: 'DocumentTypeCreate',
  components: {
    DocumentTypeDialogForm
  },
  data() {
    return {
      icon: {
        plus: mdiPlus
      },
      dialogForm: '',
      documentType: {}
    }
  },
  computed: {
    ...documentTypeStoreData
  },
  methods: {
    showDialogDocumentTypeCreate() {
      this.documentType = {
        clave: '',
        nombre: ''
      }
      this.dialogForm = 'DocumentTypeDialogForm'
    },
    close() {
      this.dialogForm = ''
    }
  }
}
</script>
